/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I4_TextInputs */

const tr_kullanim_s2_i4_text = /** @type {(inputs: Kullanim_S2_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı tarafından Platform'a yüklenen ya da Platform üzerinden işlenen veri, ürün bilgisi ve müşteri kaydı`)
};

const en_kullanim_s2_i4_text = /** @type {(inputs: Kullanim_S2_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data, product information and customer records uploaded to the Platform by the User or processed through the Platform`)
};

const de_kullanim_s2_i4_text = /** @type {(inputs: Kullanim_S2_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten, Produktinformationen und Kundendatensätze, die vom Nutzer auf die Plattform hochgeladen oder über die Plattform verarbeitet werden`)
};

const ru_kullanim_s2_i4_text = /** @type {(inputs: Kullanim_S2_I4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`данные, сведения о товарах и записи о клиентах, загруженные Пользователем на Платформу или обработанные через Платформу`)
};

/**
* | output |
* | --- |
* | "data, product information and customer records uploaded to the Platform by the User or processed through the Platform" |
*
* @param {Kullanim_S2_I4_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i4_text = /** @type {((inputs?: Kullanim_S2_I4_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I4_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i4_text(inputs)
	if (locale === "de") return de_kullanim_s2_i4_text(inputs)
	if (locale === "ru") return ru_kullanim_s2_i4_text(inputs)
	return tr_kullanim_s2_i4_text(inputs)
});